// api/maintenance/maintenanceHistoryService.js

import axiosInstance from '../axiosInstance'; // Asegúrate de que esta ruta sea correcta

/**
 * Obtiene el historial de eventos para un mantenimiento específico.
 * @param {number} manId - El ID del mantenimiento.
 * @returns {Promise<Array>} Un array de objetos de eventos de historial.
 */
export const fetchMaintenanceHistory = async (manId) => {
  const response = await axiosInstance.get(`/maintenance/records/${manId}/history`); // Ruta para el historial de un mantenimiento
  return response.data;
};

// No necesitamos funciones de create, update o delete aquí,
// ya que el historial se crea automáticamente por otras operaciones en el backend.